import { createRoot } from "react-dom/client";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import App from "./App";
import "./index.css";
import "react-day-picker/style.css";
import "./styles/daypicker-allepets.css";
import "@/styles/cards.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./styles/bootstrap-modal-lite.css";

const csrf = document
  .querySelector('meta[name="csrf-token"]')
  ?.getAttribute("content");

const pusherKey = import.meta.env.VITE_PUSHER_APP_KEY;

(window as any).Echo = null;

if (pusherKey) {
  (window as any).Pusher = Pusher;

  (window as any).Echo = new Echo({
    broadcaster: "pusher",
    key: pusherKey,
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER || "mt1",
    wsHost: import.meta.env.VITE_PUSHER_HOST || window.location.hostname,
    wsPort: 443,
    wssPort: 443,
    forceTLS: true,
    enabledTransports: ["ws", "wss"],
    disableStats: true,
    authEndpoint: "/broadcasting/auth",
    withCredentials: true,
    auth: {
      headers: {
        "X-CSRF-TOKEN": csrf || "",
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
      },
    },
  });
}

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js?v=20260427-2", {
        updateViaCache: "none",
      })
      .then((registration) => {
        console.log("Service Worker registrado");
        registration.update().catch(() => undefined);
      })
      .catch((err) => console.error("Erro SW:", err));
  });
}

createRoot(document.getElementById("root")!).render(<App />);
